export const selectLoading = (state) => state.loading.loading
